// Values written on every chart (not only in the tooltip), so they also show in exported/printed charts.
// Defaults only: a chart's own dataLabels format/formatter still wins. Installed once in main.js.

// 1,234 · 12.3k · 4.5M · 1.2bn (labels must stay short).
export function shortNumber(v) {
  if (v === null || v === undefined || v === "" || isNaN(v)) return "";
  const n = Number(v);
  const a = Math.abs(n);
  const trim = (x) => String(Math.round(x * 10) / 10);
  if (a >= 1e9) return trim(n / 1e9) + "bn";
  if (a >= 1e6) return trim(n / 1e6) + "M";
  if (a >= 1e4) return trim(n / 1e3) + "k";
  return Number.isInteger(n) ? n.toLocaleString() : (Math.round(n * 10) / 10).toLocaleString();
}

// Long series (a year of days or weeks) would be a wall of numbers: label about 24 evenly spaced points and the last.
function shownAt(index, count) {
  if (count <= 40) return true;
  return index % Math.ceil(count / 24) === 0 || index === count - 1;
}

export function installHighchartsValueLabels(Highcharts) {
  Highcharts.setOptions({
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
          formatter() {
            const v = this.point && this.point.value !== undefined && this.point.value !== null ? this.point.value : this.y;
            if (v === null || v === undefined) return null;
            const points = (this.series && this.series.points) || [];
            return shownAt(this.point.index, points.length) ? shortNumber(v) : null;
          },
        },
      },
      pie: {
        dataLabels: {
          enabled: true,
          formatter() {
            if (this.point.isNull) return null;
            return `${this.point.name}: <b>${shortNumber(this.y)}</b> (${Math.round(this.percentage)}%)`;
          },
        },
      },
      // Maps colour the areas; a number on every ward is unreadable. A map can still turn them on.
      map: { dataLabels: { enabled: false } },
    },
  });
}

function apexFormatter(val, opts) {
  const w = opts && opts.w;
  if (!w) return shortNumber(val);
  if (w.config.chart.sparkline && w.config.chart.sparkline.enabled) return "";
  if (["pie", "donut", "polarArea"].includes(w.config.chart.type)) {
    return `${shortNumber(w.globals.series[opts.seriesIndex])} (${Math.round(val)}%)`;
  }
  if (val === null || val === undefined) return "";
  return shownAt(opts.dataPointIndex, w.globals.dataPoints) ? shortNumber(val) : "";
}

// ApexCharts reads global defaults from window.Apex (merged with whatever installApexTheme set).
export function installApexValueLabels() {
  const current = window.Apex || {};
  window.Apex = {
    ...current,
    dataLabels: { ...(current.dataLabels || {}), enabled: true, formatter: apexFormatter },
  };
}

// For charts that pick their own dataLabels options: labels on, with the shared formatter.
export function valueLabels(extra = {}) {
  return { enabled: true, formatter: apexFormatter, ...extra };
}
